import { isLocal, isDevelopment } from '@/shared/config/env';

/** Inbox·헤더 벨 알림 — local / development 환경에서만 노출 */
export function isInboxFeatureEnabled(): boolean {
  return isLocal() || isDevelopment();
}
